import adminApi from "./admin";

export async function getPageBySlug(slug: string) {
	try {
		const res = await adminApi.get(
			`/pages?where[slug][equals]=${slug}&limit=1`
		);

		return res.data.docs[0].markdown;
	} catch (error) {
		console.error(error);
		throw new Error("Erro inesperado");
	}
}
